module.exports = __webpack_public_path__ + "static/media/time_afternoon.95e07f53.svg";